import { FC, useEffect, useState } from "react";
import { EActiveInvoiceStatus, EBtnType } from "@/models/common/enums";
import { MDBRow, MDBTextArea } from "mdb-react-ui-kit";
import Btn from "@/components/common/Btn";
import { TDeleteBookingBody } from "@/models/bookings";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postDeleteBooking } from "@/utils/queries";
import { useStore } from "@/store/index";
import { BookingReadableTO } from "@/models/detail";

const DeleteBookingModalBody: FC<{
    transactionId: string;
    orderId: string;
    onSuccessAfterDelete: () => void;
}> = ({ transactionId, orderId, onSuccessAfterDelete }) => {
    const [reason, setReason] = useState("");
    const queryClient = useQueryClient();

    const deleteData: TDeleteBookingBody = {
        transactionId,
        refundReason: reason,
        orderId,
    };

    const setErrorMessage = useStore(state => state.setErrorMsg);
    const setSuccessMessage = useStore(state => state.setSuccessMsg);
    const dispatch = useStore(state => state.dispatchCommon);

    const { mutate: deleteBooking, isLoading } = useMutation(
        postDeleteBooking,
        {
            onSettled: () => {
                dispatch({ type: "SET_LOADER_PAGE", payload: false });
            },
            onSuccess: () => {
                queryClient.setQueryData(
                    ["bookings-data"],
                    (oldData: BookingReadableTO[] | undefined) =>
                        oldData
                            ? oldData.map(item => ({
                                  ...item,
                                  activeInvoiceStatus:
                                      item.orderTransactionId === transactionId
                                          ? EActiveInvoiceStatus.REFUNDED
                                          : item.activeInvoiceStatus,
                              }))
                            : []
                );
                setSuccessMessage("Delete successfully", onSuccessAfterDelete);
            },
            onError: err => setErrorMessage(err as never),
        }
    );

    useEffect(() => {
        dispatch({ type: "SET_LOADER_PAGE", payload: isLoading });
    }, [isLoading]);

    return (
        <MDBRow className="g-0 py-2">
            <MDBTextArea
                className="PICustomTextArea"
                value={reason}
                id="refundReason"
                rows={4}
                onChange={e => setReason(e.target.value)}
                placeholder="Your refund reason..."
            />
            <Btn
                btnType={EBtnType.PRIMARY}
                onClick={() => deleteBooking(deleteData)}
                fullWith
                className="mt-4"
                disabled={isLoading}
            >
                Delete
            </Btn>
        </MDBRow>
    );
};

export default DeleteBookingModalBody;
